<template>
  <v-dialog v-model="dialogModel" max-width="400px">
    <v-card>
      <v-card-title
        :class="`${color} white--text title font-weight-thin`"
      >
          {{ $vuetify.t('$vuetify.common.confirmTitle') }}
      </v-card-title>

      <v-card-text id="confirmDesc">
          {{ $vuetify.t('$vuetify.common.confirmDesc') }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="color" @click="confirmed" :loading="isLoading">{{ $vuetify.t('$vuetify.common.actionText') }}</v-btn>
        <v-btn @click="$emit('cancel')" :disabled="isLoading">
          {{ $vuetify.t('$vuetify.common.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      model: {},
      color: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      },
      actionText: {
        type: String,
        required: true
      }
    },
    watch: {
      'model'() {
        this.dialogModel = !!this.model
        // If the model was closed, reset the loading
        if (this.dialogModel === false) {
          this.isLoading = false
        }
      }
    },
    data() {
      return {
        dialogModel: false,
        isLoading: false
      }
    },
    methods: {
      confirmed() {
        this.isLoading = true
        this.$emit('confirmed')
      }
    }
  }
</script>

<style>
  #confirmDesc {
    text-align: left;
  }
</style>